import BaseViewController from "./base-view-controller";
import { removeItemFromIndexedDB } from "../utils/localforage-utils";

class UploadImagesViewController extends BaseViewController {
  preprocessScreenData() {
    const maxPhotos = this.appData.values.photo_upload_limit
      ? parseInt(this.appData.values.photo_upload_limit, 10)
      : 3;
    for (let i = 1; i < maxPhotos + 1; i++) {
      const prefixPhotoKey = `__photo${i}`;
      const photoPreviewKey = `${prefixPhotoKey}:photoPreview`;
      const photoNameKey = `${prefixPhotoKey}:photoName`;

      if (
        !this.appData.values[photoPreviewKey] ||
        !this.appData.values[photoPreviewKey]?.uuid
      ) {
        removeItemFromIndexedDB(photoPreviewKey);
        this.appData.values[photoPreviewKey] = "";
        this.appData.values[photoNameKey] = "";
      }
    }
  }
}
export default UploadImagesViewController;
